import { render, staticRenderFns } from "./AdminShopOrderList.vue?vue&type=template&id=27610717&scoped=true&"
import script from "./AdminShopOrderList.vue?vue&type=script&lang=js&"
export * from "./AdminShopOrderList.vue?vue&type=script&lang=js&"
import style0 from "./AdminShopOrderList.vue?vue&type=style&index=0&id=27610717&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27610717",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27610717')) {
      api.createRecord('27610717', component.options)
    } else {
      api.reload('27610717', component.options)
    }
    module.hot.accept("./AdminShopOrderList.vue?vue&type=template&id=27610717&scoped=true&", function () {
      api.rerender('27610717', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminShopOrderList.vue"
export default component.exports